import { capitalize } from '@btime/helpers'
import { compose, defaultTo, head, identity, join, juxt, prop, tail, toUpper } from 'ramda'

// TODO: Import from helpers
export const capitalizeFirstLetter = compose(join(''), juxt([compose(toUpper, head), tail]), defaultTo(''))

export const formatEntitiesFilters = filter => {
  const entities = [
    'place', //
    'user',
    'serviceOrder',
    'form',
    'checklist',
    'segment',
    'trigger'
  ]
    .map(name => {
      const key = `entity${capitalizeFirstLetter(name)}Ids`
      const ids = prop(key, filter)

      if (!ids || !ids.length) return false
      return { model: name, ids }
    })
    .filter(identity)

  return { ...filter, entities }
}
